import { render, staticRenderFns } from "./product_alibaba.vue?vue&type=template&id=d34c177a&scoped=true&"
import script from "./product_alibaba.vue?vue&type=script&lang=js&"
export * from "./product_alibaba.vue?vue&type=script&lang=js&"
import style0 from "./product_alibaba.vue?vue&type=style&index=0&id=d34c177a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34c177a",
  null
  
)

export default component.exports